/* eslint-disable */ import { detailComponent, memoEval, sceneEntityObjectPropertiesComponent, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const fillerComponents = [
    attachComponent.withComponent(detailComponent, 'default', true).withEntity('Filler').attach(memoEval((self)=>[
            self.$name,
            self.$sku,
            self.$description
        ], ($name, $sku, $description)=>({
            title: $name,
            subtitle: $sku,
            description: $description
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'body', true).withEntity('Filler').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'PANEL_FILLER',
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'body', true).withEntity('Filler').attach(memoEval((self)=>[
            self.$offsetY,
            self.$fillerHeight,
            self.$width
        ], ($offsetY, $fillerHeight, $width)=>({
            offsetX: 0.5 * 25.4,
            offsetY: $offsetY,
            offsetZ: -1.25 * 25.4,
            morphTargetInfluences: {
                Height: {
                    value: $fillerHeight,
                    scaleZero: 30.617 * 25.4,
                    scaleOne: 36.617 * 25.4
                },
                Width: {
                    value: $width,
                    scaleZero: 1 * 25.4,
                    scaleOne: 3 * 25.4
                }
            }
        })))
];

//# sourceMappingURL=filler.js.map